import { createBrowserRouter, RouterProvider, useRouteError, Link } from "react-router-dom";
import LoginPage from './BusinessFlow/LoginPage';
import AdminLoginPage from "./AdminFlow/AdminLoginPage";
import AdminDashboard from "./AdminFlow/AdminDashboard";
import AllServiceRequests from "./AdminFlow/AdminAllServiceRequestsList";
import ExtendTenureDate from './BusinessFlow/ExtendTenureDate';
import EachLoanBreakUp from './BusinessFlow/EachLoanBreakUp';
import MyLoans from "./BusinessFlow/MyLoans";
import MyServiceRequests from "./BusinessFlow/MyServiceRequests";
import KYCDocuments from "./BusinessFlow/KYCDocuments";
import Kycform from "./BusinessFlow/Kycform";
import Notifications from "./BusinessFlow/Notifications";
import History from "./BusinessFlow/History";
import BusinessDashboard from './BusinessFlow/BusinessDashboard';
import InvestorDashboard from "./InvestorFlow/InvestorDashboard";
import MyInvestments from "./InvestorFlow/MyInvestments";
import InvestmentOpportunities from "./InvestorFlow/InvestmentOpportunities";
import InvestorKYCDocuments from "./InvestorFlow/InvestorKYCDocuments";
import InvestorHistory from "./InvestorFlow/InvestorHistory";
import InvestorNotifications from "./InvestorFlow/InvestorNotifications";
import InvestorCards from "./InvestorFlow/InvestorCards";
import AdminInvestors from "./AdminFlow/AdminInvestors";
import SingleInvestorDetails from "./AdminFlow/SingleInvestorDetails";
import BusinesswithInvDetails from "./AdminFlow/BusinesswithInvDetails";
import ListofBusinesses from './AdminFlow/ListofBusinesses';
import ParticularBusinessloanList from './AdminFlow/ParticularBusinessloanList';
import Compliance from './AdminFlow/Compliance';
import DocumentRepository from "./AdminFlow/DocumentRepository";
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import BusinessProfile from "./BusinessFlow/BusinessProfile";
import InvestorProfile from "./InvestorFlow/InvestorProfile";
import BusinessLoginEmail from "./BusinessFlow/BusinessLoginEmail";
import InvestorSettings from "./InvestorFlow/InvestorSettings";
import InvestorLoginEmail from "./InvestorFlow/InvestorLoginEmail";
import AuditorLoginPage from "./Auditor/AuditorLogin";
import { Navigate } from "react-router-dom";
import { InvestorSettingsIndividual } from "./InvestorFlow/InvestorSettingsIndividual";
import InvestorKYCFlow from "./InvestorFlow/InvestorKYCFlow";
import '@azure/ai-vision-face-ui';
import InvestorKycApprove from "./InvestorFlow/InvestorKycApprove";
import EKYCList from "./AdminFlow/EKYCList";
import EKYCDetails from "./AdminFlow/EKYCDetails";
import EKYCDetailsView from "./AdminFlow/EKYCDetailsView";
import PendingApprovals from './InvestorFlow/PendingApprovals';
import AdminSettings from './AdminFlow/AdminSettings'

Chart.register(ChartDataLabels);


const router = createBrowserRouter([
  { path: "/", element: <LoginPage />, errorElement: <ErrorElement />, },
  { path: "/businessdashboard", element: <BusinessDashboard /> },
  { path: "/investordashboard", element: <InvestorDashboard /> },
  { path: "/myinvestments", element: <MyInvestments /> },
  { path: "/investordashboard/approvals", element: <PendingApprovals /> },
  { path: "/investorapprovals", element: <PendingApprovals /> },
  { path: "/investmentopportunities", element: <InvestmentOpportunities /> },
  { path: "/investorkycdocuments", element: <InvestorKYCDocuments /> },
  { path: "/investorhistory", element: <InvestorHistory /> },
  { path: "/investornotifications", element: <InvestorNotifications /> },
  { path: "/adminlogin", element: <AdminLoginPage /> },
  { path: "/auditorlogin", element: <AuditorLoginPage /> },
  { path: "/admindashboard", element: <AdminDashboard /> },
  { path: "/allservicerequests", element: <AllServiceRequests /> },
  { path: "/extendtenuredate", element: <ExtendTenureDate /> },
  { path: "/eachloanbreakup", element: <EachLoanBreakUp /> },
  { path: "/myloans", element: <MyLoans /> },
  { path: "/myservicerequests", element: <MyServiceRequests /> },
  { path: "/kycdocuments", element: <KYCDocuments /> },
  { path: "/kycform", element: <Kycform /> },
  { path: "/notifications", element: <Notifications /> },
  { path: "/history", element: <History /> },
  { path: "/investorcards", element: <InvestorCards /> },
  { path: "/admininvestors", element: <AdminInvestors /> },
  { path: "/singleinvestordetails", element: <SingleInvestorDetails /> },
  { path: "/businesswithinvdetails", element: <BusinesswithInvDetails /> },
  { path: "/listofbusinesses", element: <ListofBusinesses /> },
  { path: "/particularbusinessloanlist", element: <ParticularBusinessloanList /> },
  { path: "/compliance", element: <Compliance /> },
  { path: "/documentrepository", element: <DocumentRepository /> },
  { path: "/businessprofile", element: <BusinessProfile /> },
  { path: "/investorProfile", element: <InvestorProfile /> },
  { path: "/businessloginemail", element: <BusinessLoginEmail /> },

  // {
  //   path: "/investorsettings",
  //   element: <InvestorSettings />,

  // },

  {
    path: "/investorsettings",
    element: <InvestorKYCFlow />,

  },
    { path: "/investorKyc", element: <InvestorKycApprove /> },

    { path: "/ekyc", element: <EKYCList /> },

  { path: "/ekyc/details/:caseId/:investor_kyc_id", element: <EKYCDetails /> },
  { path: "/ekyc/details/view/:investorId/:investor_kyc_id", element: <EKYCDetailsView/> },
  { path: "/adminsettings", element: <AdminSettings /> },
  // Old Multi-Investor Loans link: Fund Now loans now live on the Investors screen.
  { path: "/multi-investor-opportunities", element: <Navigate to="/admininvestors" replace /> },

  { path: "/investorloginemail", element: <InvestorLoginEmail /> },
]);
//commit


export default function App() {

  return <RouterProvider router={router} />;
}

function ErrorElement() {
  let error = useRouteError();
  console.error(error);

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      textAlign: "center",

    },
    header: {
      fontSize: "48px",
      color: "#333",
      marginBottom: "20px",
    },
    text: {
      fontSize: "18px",
      color: "#666",
      marginBottom: "20px",
    },
    link: {
      fontSize: "18px",
      color: "#007bff",
      textDecoration: "none",
      marginTop: "20px"
    },
  };


  return (
    <div style={styles.container}>

      <center>
        <a href=" ">
          <img className="img-fluid " src="./images/blue_brand_name.svg" alt="true" style={{ width: "450px" }} />

        </a>
        <br />
        <br />
        <table border="0" align="center" cellpadding="4">
          <tbody><tr>
            <td>
            </td>
            <td valign="middle" class="sans">
              <b class="h1">
                Looking for something?
              </b>
              <br />
              We're sorry. The Web address you entered is not a functioning page on our site.
              <br />
              <br />
              <b>
                Go to Bennefin's
                <Link to="/" style={styles.link}>
                  {" "} Home
                </Link>  Page
              </b>
            </td>
          </tr>
          </tbody>
        </table>
      </center>
    </div>
  )
}
